<div class="global-notifications" aurora-light>
    <header>
        <aurora-navbar
            class="notifications-navbar"
            orientation="horizontal"
            [small]="true"
            [noBottomBorder]="true"
            [items]="navbarItems"
            [selectedId]="activeTab"
            (item-click)="onNavbarItemClick($event)">
        </aurora-navbar>

        <div class="actions">
            <aurora-icon-button
                id="closeNotificationsButton"
                icon="times"
                size="medium"
                label="Close notifications"
                (click)="onClose.emit()">
            </aurora-icon-button>
        </div>
    </header>

    <div id="tabContent" class="tab-content">
        @if (activeTab === 'Notifications') {
        <div *ngIf="sortedAndFilteredNotifications.length === 0" class="notifications-empty-state">
            There are no notifications
        </div>

        <ng-container *ngFor="let card of sortedAndFilteredNotifications; trackBy: trackByNotificationId">
            <sm-global-notifications-card
                aurora-light
                [id]="'notification:' + card.Id"
                [vm]="card"
                (onClose)="onClose.emit($event)"
                (onClickLink)="onClickLink.emit($event)"/>
        </ng-container>
        } @else if (activeTab === 'Settings') {
        <div class="settings-tab-content">
            <sm-notification-settings [renderMode]="'inline'"></sm-notification-settings>
        </div>
        }
    </div>
</div>
